import React, { useEffect, useRef, useState } from 'react';
import { toJS } from 'mobx';

const BaseballBroadCastItem = ({ data, period, selectedPeriod }) => {
  const [viewDetail, setViewDetail] = useState(false);
  const titleComp = useRef();

  const handleToggleDetail = () => {
    const changeView = !viewDetail;
    setViewDetail(!viewDetail);
    if (changeView) {
      const targetScroll = titleComp.current.offsetTop;
      setTimeout(() => {
        window.scrollTo({ top: targetScroll, behavior: 'smooth' });
      }, 10);
    }
  };

  useEffect(() => {
    if (selectedPeriod === parseInt(period)) {
      setViewDetail(true);
    }
  }, []);
  return (
    <dl className={`item ${viewDetail && 'view'}`}>
      <dt onClick={handleToggleDetail} ref={titleComp}>
        <span className="tit">{period}회</span>
        <button type="button" className="btn_oc">
          열기/닫기
        </button>
      </dt>
      <dd>
        {data.map((item, key) => {
          const { player, notify, eventTexts } = item;
          return (
            <div className="box" key={key}>
              {player !== null && <span className="player">{player}</span>}
              {notify !== null && <span className="notify">{notify}</span>}
              {eventTexts.map((text, textKey) => {
                return <span key={textKey}>{text}</span>;
              })}
            </div>
          );
        })}
      </dd>
    </dl>
  );
};

export default BaseballBroadCastItem;
